import { AppBar, styled, Toolbar } from "@mui/material";

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  boxShadow: "none",
  borderBottom: `1px solid ${theme.palette.divider}`,
}));
export const StyledToolbar = styled(Toolbar)(() => ({
 display: "flex", 
 justifyContent: "space-between",
}));